import { connect } from 'react-redux';
import Lines from './Lines';
import { selectors as purchaseOrdersSelectors } from 'ducks/purchaseOrders/purchaseOrders';
import React from 'react';
import { ILinesHandle, ILinesProperties } from './Lines.properties';

const params = new URLSearchParams(location.search);

const mapStateToProps = (state) => ({
    selectedPurchaseOrder: purchaseOrdersSelectors.selected(state)?.PurchaseOrder ?? params.get('PurchaseOrder'),
});

const ContainerComponent = (props: Omit<ILinesProperties, 'classes' | 'calculateCellValueChange'> & { forwardRef?: React.Ref<ILinesHandle> }) => {

    return <Lines
        {...props}
        innerRef={props?.forwardRef}
    />;
};

export default connect(mapStateToProps, null)(React.forwardRef(ContainerComponent));
